import styled from 'styled-components'
import { Box } from 'rebass'
import media from '../../../utils/style'

const FilterOptions = styled(Box)`
  position: absolute;
  top: 71px;
  left: -100%;
  z-index: 20;
  transition: left 0.4s ${(props) => props.theme.ease.ease_out_cubic};
  background-color: white;
  min-height: 400px;
  &::before {
    content: '';
    position: absolute;
    z-index: 0;
    bottom: 0;
    left: 0%;
    width: 100%;
    height: 100%;
    box-shadow: 0 60px 60px 0 rgba(66, 76, 94, 0.05),
      0 25px 25px 0 rgba(0, 0, 0, 0.03);
  }
  & .pointer {
    cursor: pointer;
  }
  & form {
    position: relative;
    z-index: 0;
  }

  &.visible {
    left: 0;
  }

  ${media.LargeScreenUp`
    position: relative;
    top: 0;
    left: 0;
    z-index: 20;
  `};
`

FilterOptions.displayName = 'FilterOptions'

export default FilterOptions
